export const companyMd = `# 实体：公司 (Company)

  ## 1. 公司基础信息 (Company.BasicInfo)

  -   **公司名称 (Name):** 珍岛信息技术（上海）股份有限公司
  -   **公司简称 (ShortName):** Marketingforce, 迈富时, 珍岛集团
  -   **成立时间 (FoundingTime):** "2009年"
  -   **总部所在地 (Headquarters):** "上海市静安区江场路1401弄上海市大数据产业基地"


  ## 2. 公司级核心价值与背景 (Company.OverallValue)

  -   **公司级行业痛点描述 (CompanyPainPoints):**
      -   "获客成本居高难下"
      -   "客户信息资产管理困难"
      -   "数据孤岛，数据价值无法挖掘"
      -   "私域资产增值困难"
      -   "营销效果难以量化与追踪"
      -   "企业数字化转型路径模糊"
      -   "缺乏持续增长的核心驱动力"
      -   "服务过程难掌控，用户体验不统一"
      -   "客户流失率高"

  -   **公司级战略定位/方法论 (CompanyStrategy):**
      -   "全球领先的AI SaaS智能营销云平台"
      -   "聚焦数字化与智能化，提供有竞争力的产品与服务，持续为客户创造价值"
      -   "打造 IaaS/PaaS/SaaS三层服务架构，为企业提供灵活、经济的软件服务及个性化拓展"
      -   "以“企业数字化、智能化增长”为核心，提供高价值解决方案"
      -   "AI Agent赋能千行百业"
      -   "从流量池到心智池的跃迁"

  -   **所获荣誉与认证 (AwardsAndCertifications):**
      -   "中国最大的营销及销售SaaS公司 (来源：弗若斯特沙利文)"
      -   "国家科学技术进步二等奖 (国务院颁发)"
      -   "上海市科学技术奖一等奖"
      -   "连续7年蝉联AI SaaS影响力企业第一名"
      -   "国家中小企业公共服务示范平台"
      -   "中国互联网百强企业"
      -   "国家高新技术企业"
      -   "示范院士专家工作站"
      -   "上海软件和信息技术服务业百强"
      -   "2020上海软件核心竞争力企业（创新型）"
      -   "《2025年全球企业级AI Agent优秀厂商图谱》入选"
      -   "年度人工智能引领奖 (STIF第五届国际科创节)"
      -   "科技企业ESG先锋奖 (STIF第五届国际科创节)"
      -   "腾讯智慧零售“千域计划”三项大奖"
      -   "2024业务中台企业TOP2 (中国社科院信息化研究中心联合《互联网周刊》)"
      -   "累计申请软件著作和专利750余项"

  -   **融资情况 (Funding):**
      -   **轮次:** 上市
      -   **股票代码:** "02556.HK"

  -   **团队背景 (TeamBackground):**
      -   **团队规模:** "团队规模4000+", "千人规模研发团队"
      -   **核心成员履历:**
          -   "赵旭隆，Marketingforce迈富时创始人&董事长"
          -   "Gary Zhao (赵国帅)，集团执行董事、联席董事长及全球执行总裁，前HPE战略总顾问、OpenText生态联盟执行主席"
          -   "付尧，集团副总裁，拥有近20年跨行业数智化服务与团队管理经验，曾服务于IBM、Toshiba等"
          -   "顶尖技术团队，90%以上为硕士和博士，毕业于国内外顶级院校"
      -   **团队专长:** "大数据、人工智能技术、云计算在数字营销及企业数字化转型领域的创新与整合"

  -   **公司市场数据/规模 (CompanyMarketData):**
      -   **指标名称:** "服务客户数量", **数值:** 200000, **单位:** "家", **时间点/周期:** "累计"
      -   **指标名称:** "覆盖分支机构", **数值:** 20, **单位:** "余家", **对比基准:** "全球"
      -   **指标名称:** "获客投入", **数值:** 58, **单位:** "%", **对比/增减类型:** "下降"
      -   **指标名称:** "成交时间", **数值:** 35, **单位:** "%", **对比/增减类型:** "加快"
      -   **指标名称:** "客单价", **数值:** 46, **单位:** "%", **对比/增减类型:** "整体提升"
      -   **指标名称:** "客户满意度", **数值:** 25, **单位:** "%", **对比/增减类型:** "提高"

  ## 3. 核心产品线与市场定位 (Company.ProductLines)

  ### **核心产品线：营销云 (Marketing Cloud)**

  -   **产品列表 (ProductList):**
      -   **产品名称 (ProductName):** T云
      -   **产品定位/口号 (ProductSlogan):** "轻松获取线索，高效开展营销"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["网络流量获取难", "营销物料生产效率低", "多渠道管理复杂", "营销效果无法闭环分析"]
      -   **技术原理/架构 (TechnicalPrinciple):** "SaaS化部署", "PaaS中台", "行业专属大模型"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "平台智能搭建", **功能描述:** "快速完成官网、小程序、电子名片、H5页面等平台的灵活配置与搭建。", **解决痛点:** "建站门槛高"
          -   **功能名称:** "内容智能生成", **功能描述:** "内置臻文、臻图、臻视等AI工具，通过AI助力高效生产文章、图片、短视频等营销素材。", **解决痛点:** "内容生产效率低", "创意枯竭"
          -   **功能名称:** "内容智能分发", **功能描述:** "覆盖搜索、媒体、短视频、微信四大主流生态，实现多渠道一键分发与管理。", **解决痛点:** "多平台手动发布耗时费力"
          -   **功能名称:** "商机洞察", **功能描述:** "提供营销全链路数据捕捉分析，包括流量监测、AI测评、BI决策支持。", **解决痛点:** "数据分散难以归因", "营销效果不透明"
      -   **产品技术优势/独特性 (ProductTechAdvantages):** "PaaS中台支持快速增加新功能板块，抢占新渠道流量红利", "全布局埋点，沉淀海量行业数据，形成行业专属大模型"

      -   **产品名称 (ProductName):** 视频魔方
      -   **产品定位/口号 (ProductSlogan):** "轻松玩转企业短视频营销"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["账号定位困难", "内容创作乏力", "短视频流量无法破圈", "运营经验缺乏"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "AI脚本创作", **功能描述:** "提供核心主题及对应指令，AI辅助快速生成创意短视频脚本。", **解决痛点:** "内容创意不足"
          -   **功能名称:** "AI脚本仿写", **功能描述:** "输入热门脚本内容，一键仿写，分分钟生成相似热门同款短视频脚本。", **解决痛点:** "内容创作效率低"
          -   **功能名称:** "视频拓词", **功能描述:** "根据短视频标签规则智能生成热门话题、关键词，发布时智能添加，提升视频权重和播放量。", **解决痛点:** "流量无法破圈"
          -   **功能名称:** "多平台矩阵分发", **功能描述:** "一站式管理多渠道视频账号数据，打造视频流量池。", **解决痛点:** "多账号操作繁琐"
          -   **功能名称:** "同城拓客", **功能描述:** "AI智能生成宣传视频获客二维码，适合餐饮、健身、教育等本地生活行业进行二次营销裂变。", **解决痛点:** "获客成本高"

      -   **产品名称 (ProductName):** 自媒体矩阵
      -   **产品定位/口号 (ProductSlogan):** "从自媒体内容创作到线索转化的一站式赋能"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["多平台账号管理繁琐", "内容创作效率低", "内容合规风险", "运营效果难以追踪"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "多账号统一管理", **功能描述:** "多平台、多账号同时管理，保障品牌一致性。", **平台支持:** ["百家号", "头条号", "知乎", "微信公众号", "新浪微博", "企鹅号", "搜狐号", "大鱼号", "惠头条", "快传号"]
          -   **功能名称:** "内容智能生成", **功能描述:** "多标题、摘要、标签智能生成，辅助提升搜索排序，获得更多推荐曝光。", **解决痛点:** "内容创作乏力"
          -   **功能名称:** "智能风险预警", **功能描述:** "智能检测内容中是否含有涉政、暴恐、色情、广告等信息，规避风险。", **解决痛点:** "平台风控压力大"
          -   **功能名称:** "多平台一键分发", **功能描述:** "多体裁一键同步分发至10+主流自媒体平台，减少繁琐重复操作。", **解决痛点:** "手动发布耗时费力"
          -   **功能名称:** "运营数据可视化", **功能描述:** "打通自媒体内容全链路流转数据，商机线索、私信留言直观展示，让内容营销效果可视化。", **解决痛点:** "数据分散难以归因"

      -   **产品名称 (ProductName):** 宝盟
      -   **产品定位/口号 (ProductSlogan):** "您身边的AI推广智投管家"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["缺乏互联网营销经验", "缺少专业型人才", "推广预算成本有限", "缺乏品牌营销意识"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "智能定投", **功能描述:** "无需备案，在高权重B2B站点进行智能定投发布。", **解决痛点:** "传统SEO效果衰减"
          -   **功能名称:** "AI智能操作", **功能描述:** "平台战略合作，商机智能分发，无需人工操作，智能拓词、智能商情分发、智能定时发布。", **解决痛点:** "人工操作效率低下"
          -   **功能名称:** "智能刷新", **功能描述:** "检测发布信息页面可访问状态，智能推荐商机更新，多渠道吸引流量。", **解决痛点:** "排名不稳定"
      -   **产品技术优势/独特性 (ProductTechAdvantages):** "聚拢了中文B2B平台80%的商业流量，每月3000多万的IP", "多家战略联盟覆盖80%的B2B流量"

      -   **产品名称 (ProductName):** T云海外版
      -   **产品定位/口号 (ProductSlogan):** "让海外营销变简单！"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["打开海外市场难", "缺乏海外客户线索", "营销活动建立复杂", "企业数据资产无法沉淀"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "平台智能搭建", **功能描述:** "提供智能化的独立站搭建平台，无需专业技术知识，快速灵活搭建个性化平台。", **解决痛点:** "技术门槛高"
          -   **功能名称:** "海外企业数据库", **功能描述:** "提供海外企业信息和联系方式的数据库，帮助用户快速找到目标市场的潜在客户。", **解决痛点:** "获客渠道单一"
          -   **功能名称:** "自动化营销流程", **功能描述:** "通过大数据和AI技术，自动执行销售动作，包括线索获取、跟进、推送信息等，实现24小时不间断的销售活动。", **解决痛点:** "人工操作效率低下"
          -   **功能名称:** "多方式触达转化", **功能描述:** "通过邮件、Whatsapp、社交媒体等渠道与潜在客户建立联系，进行个性化沟通和推广。", **平台支持:** [、"Whatsapp", "社交媒体"]

      -   **产品名称 (ProductName):** GMA增长营销自动化平台
      -   **产品定位/口号 (ProductSlogan):** "让企业拥有持续增长核心驱动力"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["运营活动策略制定难", "用户筛选不精准", "用户触达手段单一", "活动效果分析不实时"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "流程画布", **功能描述:** "可视化搭建自动营销流程，构建个性化的用户旅程，在不同触点自动化地传递信息，引导用户转化。", **解决痛点:** "营销流程复杂", "客户流失严重"
          -   **功能名称:** "用户精准筛选", **功能描述:** "通过用户属性和行为数据洞察，丰富的分群和标签随需随取，快速筛选精准人群。", **解决痛点:** "缺乏360°客户视图"
          -   **功能名称:** "多渠道精细化触达", **功能描述:** "打通短信、微信、弹框、APP推送等多种用户触达通道。", **解决痛点:** "触达方式单一"
          -   **功能名称:** "实时效果分析", **功能描述:** "提供实时的活动看板，让运营效果一览无遗，数据驱动方案迭代。", **解决痛点:** "营销效果不透明"

      -   **产品名称 (ProductName):** 社媒VOC（客户之声）
      -   **产品定位/口号 (ProductSlogan):** "全面倾听客户的反馈和需求"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["无法高效全面监测社媒口碑", "负面舆情响应滞后", "营销活动效果评估难", "竞品分析效率低"]
      -   **技术原理/架构 (TechnicalPrinciple):** "NLP语义分析", "传播影响力模型", "发酵模型", "异常账号识别模型"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "一站式社媒监测", **功能描述:** "监测范围覆盖国内外主流社媒、传统网媒、搜索引擎；80%帖子发布1小时内能够监测到。", **解决痛点:** "信息获取不及时"
          -   **功能名称:** "负面舆情识别与预警", **功能描述:** "通过NLP语义分析识别负面声音，并按照发帖人粉丝数、互动数等进行分级、分角色预警。", **平台支持:** ["飞书", "钉钉", "企业微信"]
          -   **功能名称:** "营销活动效果分析", **功能描述:** "AI筛选活动发帖，通过活动声量趋势、情感度趋势、词云等评估活动效果并及时调整策略。", **解决痛点:** "营销效果不透明"
          -   **功能名称:** "社媒获客与线索挖掘", **功能描述:** "通过算法挖掘筛选评论、私信及弹幕中高意向客户，形成社媒线索池。", **解决痛点:** "获客渠道单一"

  ### **核心产品线：销售云 (Sales Cloud)**

  -   **产品列表 (ProductList):**
      -   **产品名称 (ProductName):** 珍客SCRM (SCRM私域客户资产运营)
      -   **产品定位/口号 (ProductSlogan):** "构建全链路私域运营，打造数字化客户资产管理平台"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["公域流量贵，获客成本高", "触达方式单一，用户易流失", "销售服务水平不一", "用户复购率低"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "全渠道获客", **功能描述:** "连接智能广告平台，打通公域到私域，基于大数据分析投放效果，反哺获客渠道(look-alike)，提高投放ROI。", **解决痛点:** "获客成本高"
          -   **功能名称:** "自动化精准触达", **功能描述:** "接入营销自动化MA，基于客户全生命周期管理，触发自动化营销内容，实现千人千面营销。", **解决痛点:** "用户流失严重"
          -   **功能名称:** "标准化展业", **功能描述:** "提供“话术库+素材库+客户SOP”的黄金展业组合，为销售人员赋能，快速提升服务水平。", **解决痛点:** "销售能力参差不齐"
          -   **功能名称:** "会话风控质检", **功能描述:** "支持会话存档和敏感词提醒，规范销售管理过程，保障企业客户资产。", **解决痛点:** "客户资产流失"

      -   **产品名称 (ProductName):** 客户数据平台CDP
      -   **产品定位/口号 (ProductSlogan):** "打通全域数据构建360°企业用户画像"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["数据孤岛", "用户画像不清晰", "无法进行精细化运营", "线索转化率低"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "多源数据接入与治理", **功能描述:** "支持mysql、hive等多种数据库、excel/csv文件及API接口对接，提供可视化建模进行数据清洗。", **解决痛点:** "数据孤岛"
          -   **功能名称:** "One-ID体系", **功能描述:** "整合客户数据，打通各渠道的用户ID，识别并合并多用户关系，形成统一用户视图。", **解决痛点:** "客户信息分散"
          -   **功能名称:** "360°用户洞察", **功能描述:** "通过对客户360°画像及分群透视分析，帮助进行精细化运营、个性化触达、精准投放。", **解决痛点:** "缺乏360°客户视图"
          -   **功能名称:** "标签与分群能力", **功能描述:** "支持规则创建、导入创建、lookalike等11种模式创建标签和分群，高效完成用户标签体系。", **解决痛点:** "用户分层管理难"

      -   **产品名称 (ProductName):** 珍客CRM (CRM客户关系管理)
      -   **产品定位/口号 (ProductSlogan):** "提供企业销售数字化转型的综合解决方案"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["客户信息管理混乱", "销售流程不规范", "商机转化率低", "缺乏数据分析辅助决策"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "360度客户洞察", **功能描述:** "展示客户全生命周期的活动，从线索到成交，让销售清晰掌握客户的每一个活动。", **解决痛点:** "客户信息分散"
          -   **功能名称:** "商机管理", **功能描述:** "精细化管理每个商机，通过制定每个阶段的任务和动作，指导销售更高效的转化商机。", **解决痛点:** "销售流程混乱"
          -   **功能名称:** "移动办公", **功能描述:** "支持通过浏览器或移动应用，让销售随时随地查阅和更新销售进展。", **解决痛点:** "销售效率低"
          -   **功能名称:** "Sales Analytics", **功能描述:** "基于BI能力，将报表与驾驶舱能力与CRM相结合，支持多样的报表可视化与钻取分析。", **解决痛点:** "缺乏数据驱动决策"

      -   **产品名称 (ProductName):** 臻推宝
      -   **产品定位/口号 (ProductSlogan):** "想要销售好，就用“臻推宝”"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["销售线索难找", "客户信任难建立", "营销物料制作耗时", "客户资产无法沉淀"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "智能商务名片", **功能描述:** "每个员工专属的微信小程序名片，360°全景展示个人、公司、产品信息，链接12亿微信用户生态圈。", **解决痛点:** "品牌曝光不足"
          -   **功能名称:** "全员智能推广系统", **功能描述:** "提供品牌海报、热点文库、宣传册等系统，支持一键生成和分享，实现社群裂变。", **解决痛点:** "内容创作效率低"
          -   **功能名称:** "有效获客转化系统", **功能描述:** "实时掌握访客行为轨迹，智能分析客户意向，并通过在线客服系统快速沟通，不加微信好友也能沟通。", **解决痛点:** "客户意向不明确"
          -   **功能名称:** "销售分析管理系统", **功能描述:** "提供推广数据看板，实现订单数据可视化，将访客信息沉淀为企业客户资产池。", **解决痛点:** "客户资产流失"

      -   **产品名称 (ProductName):** AI-Sales 海外销售专家 (Eva, Nora, Max)
      -   **产品定位/口号 (ProductSlogan):** "AI驱动的海外销售专家"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["传统海外开发效率低", "目标客户不精准", "决策人难找", "营销内容缺乏个性化", "人力成本高"]
      -   **技术原理/架构 (TechnicalPrinciple):** "千亿级海外数据智库", "AI Agent"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "Eva - 海外开发专家", **功能描述:** "基于千亿级海外数据智库，智能搜索并开发潜在客户，智能发送个性化营销邮件。", **解决痛点:** "获客渠道单一"
          -   **功能名称:** "Nora - 社媒营销顾问", **功能描述:** "智能生成社媒内容计划，自动排期发布，精准互动，打造品牌影响力。", **解决痛点:** "内容生产效率低"
          -   **功能名称:** "Max - 客户销售管家", **功能描述:** "自动跟进客户动态，更新客户画像，提升复购率和客户忠诚度。", **解决痛点:** "客户跟进不及时"
      -   **产品技术优势/独特性 (ProductTechAdvantages):** "覆盖200+国家市场，自动适配时区与语言", "每日分析百万次交互数据，动态优化营销策略"

  ### **核心产品线：商业云 (Business Cloud)**

  -   **产品列表 (ProductList):**
      -   **产品名称 (ProductName):** 智能体商城 (T-SHOP 智慧商城)
      -   **产品定位/口号 (ProductSlogan):** "打通企业线上线下商业能力"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["多渠道店铺管理难", "缺乏新零售场景支持", "营销活动单一", "运营人效低"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "全渠道整合", **功能描述:** "一站式管理微信小店、抖音、天猫、京东等多渠道的商品、订单、营销、物流、售后。", **平台支持:** ["视频号", "天猫", "京东", "快手", "抖音", "小红书"]
          -   **功能名称:** "多场景适配", **功能描述:** "高度灵活定义，可快速搭建社交电商、内容电商、分销商城、会员商城等新零售场景。", **解决痛点:** "业务场景支持不足"
          -   **功能名称:** "大数据智能", **功能描述:** "运用大数据、人工智能技术，通过对消费者行为和偏好的分析，提供个性化的推荐和定制化的服务。", **解决痛点:** "缺乏个性化推荐"
          -   **功能名称:** "丰富的营销活动", **功能描述:** "支持优惠券、打折、促销、秒杀、满减等丰富营销模式，实现快速引流转化。", **解决痛点:** "营销玩法单一"

      -   **产品名称 (ProductName):** 智慧门店 (T-Shop 智慧门店)
      -   **产品定位/口号 (ProductSlogan):** "有效整合线上与线下门店的资源、打破传统门店的边界"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["线上线下业务脱节", "客户忠诚度低、复购率低", "门店管理效率低", "缺乏数据驱动决策"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "营销赋能", **功能描述:** "通过全链路激活促销、建立完善的会员体系等方式，高效提高客户的忠诚度和复购率。", **解决痛点:** "客户留存率低"
          -   **功能名称:** "管理赋能", **功能描述:** "提供有效的商品库存管理系统、订单分佣机制和数字化的决策支持。", **解决痛点:** "管理流程复杂"
          -   **功能名称:** "多渠道快速引流", **功能描述:** "构建会员体系和数字化营销工具，高效地将流量引导至线上及线下门店。", **解决痛点:** "获客渠道单一"

      -   **产品名称 (ProductName):** 会员中心 (T-Shop 会员中心)
      -   **产品定位/口号 (ProductSlogan):** "全渠道线上线下会员管理平台"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["多渠道会员数据不通", "会员体系单一", "用户活跃度和复购率低"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "全渠道对接", **功能描述:** "对接京东、淘宝、拼多多、小红书、抖店、快手等平台整合全渠道会员数据，一站式查看管理。", **平台支持:** ["京东", "淘宝", "小红书", "拼多多", "有赞", "微盟", "美团", "抖店"]
          -   **功能名称:** "多会员体系", **功能描述:** "支持商户同时配置多套会员模板，适配大型企业一品牌一会员体系的运营场景。", **解决痛点:** "集团多品牌管理难"
          -   **功能名称:** "会员激励体系", **功能描述:** "支持会员分销、会员勋章、积分商城等玩法，促进用户活跃与复购。", **解决痛点:** "用户互动低迷"

  ### **核心产品线：分析云 (Analysis Cloud)**

  -   **产品列表 (ProductList):**
      -   **产品名称 (ProductName):** 智能可视化BI
      -   **产品定位/口号 (ProductSlogan):** "支持千亿级数据、亚秒级查询，让客户轻松的洞察数据价值"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["数据分散在多系统", "IT知识门槛高", "数据分析维度单一", "缺乏预测性洞察"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "轻松整合数据", **功能描述:** "具有强大的数据集成能力，能够从ERP、CRM、财务系统等多个源头抽取数据，打破数据孤岛。", **解决痛点:** "数据孤岛"
          -   **功能名称:** "零门槛数据探索", **功能描述:** "提供直观易用的界面和拖拽式报告生成工具，支持自动生成图表、自然语言交互。", **解决痛点:** "IT运维依赖专职人员"
          -   **功能名称:** "AI智能应用模型", **功能描述:** "连接采购、库存、物流等环节，提供实时关键指标，辅助企业做出最佳采购决策；整合员工信息、绩效数据等，发现人才流失原因。", **解决痛点:** "缺乏数据驱动决策"
          -   **功能名称:** "自定义指标预测", **功能描述:** "利用预测分析能力，企业可提前预警潜在的财务风险，并依据历史和趋势数据调整财务策略。", **解决痛点:** "缺乏风险预警"

  ### **核心产品线：智能云 (Smart Cloud)**

  -   **产品列表 (ProductList):**
      -   **产品名称 (ProductName):** AI-Agentforce智能体中台
      -   **产品定位/口号 (ProductSlogan):** "打造企业级、生产级的智能体（Agent）一站式开发与运营平台"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["自研智能体开发周期长、技术风险高、运维成本大", "AI试水难以走向AI工业化", "技术门槛高", "缺乏可复用的AI能力"]
      -   **技术原理/架构 (TechnicalPrinciple):** "Agentic工作流编排", "RAG知识引擎", "智能体DevOps全生命周期管理", "多模态AI Agent引擎"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "一体化开发", **功能描述:** "一个平台集成框架设计、知识库管理、API连接、工作流编排、模型调度，降低开发门槛。", **解决痛点:** "AI营销落地技术门槛高"
          -   **功能名称:** "分钟级构建", **功能描述:** "提供上百个行业场景智能体模板，业务人员像组装乐高一样搭建流程。修改知识库或流程逻辑秒级生效。", **解决痛点:** "需求响应滞后"
          -   **功能名称:** "统一运维", **功能描述:** "实时监控Agent运行状态、自动告警异常、分析性能瓶颈，实现全程可视化管理。", **解决痛点:** "系统运维复杂"
          -   **功能名称:** "多租户私有化部署", **功能描述:** "支持集团内部多子公司、部门共享系统资源，同时拥有逻辑隔离的专属开发空间，实现企业级安全管控。", **解决痛点:** "数据安全与合规压力"
      -   **产品技术优势/独特性 (ProductTechAdvantages):** "将企业AI生产力重构为“可复用的能力层”", "“自然语言驱动+可视化编排”的双模交互", "支持“智能体市场”共享模板与最佳实践"

      -   **产品名称 (ProductName):** T-Talk智能客服
      -   **产品定位/口号 (ProductSlogan):** "提人效，促成单，访客接待一体化"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["客户来源渠道分散，接待耗时", "大量重复问题导致客服人效低", "非工作时间无人接待", "无法提前预判客户意图"]
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "全渠道接入, 7*24 全天候接待", **功能描述:** "支持接入官网、APP、商铺等站点，机器人客服随时响应，无缝衔接人工。", **解决痛点:** "响应滞后"
          -   **功能名称:** "内置行业语料", **功能描述:** "行业语料库轻松导入，机器人懂行会接话，提供侧边栏快捷回复，支持人机协作提效。", **解决痛点:** "客服专业能力不足"
          -   **功能名称:** "营销小组件", **功能描述:** "提供6种入口样式，9种邀请弹窗，互动吸睛引导会话，超时未接待时主动引导留资。", **解决痛点:** "线索转化率低"
          -   **功能名称:** "精准记录访客轨迹", **功能描述:** "访客看板记录访客来源、访问轨迹，了解访客兴趣点，精准洞察用户需求。", **解决痛点:** "缺乏客户洞察"

      -   **产品名称 (ProductName):** 臻文
      -   **产品定位/口号 (ProductSlogan):** "为用户提供更新快、覆盖全、质量高的原创文章内容和辅助创作平台"
      -   **技术原理/架构 (TechnicalPrinciple):** "自然语言处理", "知识图谱", "深度学习", "语义分析"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "智能辅助创作", **功能描述:** "海量专业素材智能推荐，主题写作一键生成标题、摘要等。", **解决痛点:** "创意枯竭"
          -   **功能名称:** "文章生成", **功能描述:** "设定创作主题、行业，即可批量生成原创文章。", **解决痛点:** "内容生产效率低"
          -   **功能名称:** "原创改写", **功能描述:** "对已有文章进行在线快速改写，支持批量原创、锁词、替换词等操作。", **解决痛点:** "内容同质化"

      -   **产品名称 (ProductName):** 臻图
      -   **产品定位/口号 (ProductSlogan):** "智能营销设计云平台"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "AI绘图", **功能描述:** "支持文生图、图生图，6秒生成，8000+词汇组合助力艺术创作。", **解决痛点:** "缺乏高质量图片素材"
          -   **功能名称:** "智能生成", **功能描述:** "根据固定主图智能生成多张场景图片，快速赋能营销。", **解决痛点:** "设计效率低"
          -   **功能名称:** "自动抠图", **功能描述:** "一键智能抠图，自动识别主体并剔除背景，发丝清晰可见。", **解决痛点:** "图片处理复杂"

      -   **产品名称 (ProductName):** 臻视
      -   **产品定位/口号 (ProductSlogan):** "全能易用的短视频创作推广工具"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "模板广场", **功能描述:** "提供海量视频模板，匹配企业全场景业务需求，一键套用，极速生成。", **解决痛点:** "缺乏专业视频制作能力"
          -   **功能名称:** "图文快闪", **功能描述:** "无需基础，替换图文，1秒即可生成爆款快闪卡点视频。", **解决痛点:** "传统视频制作周期长"
          -   **功能名称:** "AI智能配音与字幕", **功能描述:** "旁白声音自由选择，语速快慢任意切换；机器自动识别语音，一键完成字幕添加。", **解决痛点:** "视频后期制作复杂"

      -   **产品名称 (ProductName):** 智能体一体机
      -   **产品定位/口号 (ProductSlogan):** "智慧、安全、高效的最新一代解决方案"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["数据安全约束，必须私有化部署", "公文/报告等需求响应低效", "大模型落地技术适配门槛高"]
      -   **部署方式 (DeploymentMethod):** "私有化部署"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "20+政务智能体", **功能描述:** "提供法律法规问询、纪检信访回复、招商辅助、公文拟制、政策文件解析等超过20种开箱即用的政务智能体。", **解决痛点:** "政务办公效率低"
          -   **功能名称:** "数据安全保障", **功能描述:** "能够根据政府的组织架构、管理规范进行租户隔离,支持安全管理机制。", **解决痛点:** "数据安全与合规压力"
          -   **功能名称:** "多模型协作架构", **功能描述:** "支持多模型调度及管理,支持租户级隔离机制。", **解决痛点:** "技术适配门槛高"
      -   **产品技术优势/独特性 (ProductTechAdvantages):** "AI国产化+自主可控，构建政企数智新生态", "软硬件一体化交付"

  ### **核心产品线：组织云 DHR (DHR Cloud)**

  -   **产品列表 (ProductList):**
      -   **产品名称 (ProductName):** DHRforce (德招聘, 德人才, 德学堂)
      -   **产品定位/口号 (ProductSlogan):** "基于Tforce大模型的人才甄选、人岗匹配与人才发展一体化智能管理平台"
      -   **产品解决的行业痛点 (ProductSpecificPainPoints):** ["人才获取渠道单一", "人才识别不准", "人事管理效率低", "人才培养体系不健全"]
      -   **技术原理/架构 (TechnicalPrinciple):** "Tforce大模型AIGC与智能体中台"
      -   **核心功能模块 (FeatureModules):**
          -   **功能名称:** "德招聘-智能招聘", **功能描述:** "全流程自动化，对接10+外部招聘渠道，提供智能简历解析和筛查，实现AI人岗匹配。", **解决痛点:** "招聘效率低", "人才识别失误率高"
          -   **功能名称:** "德人才-人才测评", **功能描述:** "全面覆盖人才评估冰山模型，提供心理风险评估、认知能力测评、关键岗位潜质测评等。", **解决痛点:** "人才评估不科学"
          -   **功能名称:** "德学堂-在线培训", **功能描述:** "提供AI陪练助手模拟真实业务场景，AI出题出卷与智能批阅，新员工入职自动推送学习计划。", **解决痛点:** "培训效果难以量化"
      -   **产品技术优势/独特性 (ProductTechAdvantages):** "AI+招测学考一体化流程，从精准识人到精准用人", "深入招、测、学全场景的一体化HR SaaS方案"

  ## 4. 产品级行业适配与价值主张 (Company.Product.IndustryFit)

  -   **目标行业 (TargetIndustries):** ["零售消费", "汽车", "金融保险", "B2B制造业", "教育", "医疗大健康", "政务", "家居电工", "跨境电商", "家装", "餐饮"]
  -   **客户群体特征 (ClientCharacteristics):** ["中大型企业", "集团企业", "中小微企业", "出海企业", "院校", "政府机构"]

  ## 5. 产品级典型应用案例与量化成果 (Company.Product.CaseStudies)

  -   **案例列表 (CaseList):**
      -   **案例场景/客户描述:** "公牛集团（家居电工与照明）"
      -   **实施策略/功能应用:** "以“全域场景触达 + 客资精细运营 + 组织能力培育”的数智策略，部署微信小程序商城、SCRM系统、自媒体矩阵运营体系和“德学堂”员工培训平台。"
      -   **关联价值:** "让线下门店从交易场景升级为全域运营的枢纽，让导购的服务经验转化为标准化的组织能力，让品牌与用户的每一次互动都成为可沉淀的运营资产。"

      -   **案例场景/客户描述:** "某医药大健康品牌"
      -   **实施策略/功能应用:** "部署AI-Agentforce企业级智能体中台，通过“AI+CDP”打通全渠道数据，构建360度客户档案；AI Agent进行分层式用户管理并自动识别复购黄金期，精准推送会员活动。"
      -   **成果指标:**
          -   **指标名称:** "新会员转化率", **对比/增减类型:** "大幅提升"
          -   **指标名称:** "全域会员GMV", **对比/增减类型:** "突破历史新高"

      -   **案例场景/客户描述:** "某头部新能源车企"
      -   **实施策略/功能应用:** "部署AI数字员工，作为24小时在线咨询顾问，精准捕捉用户需求并记录标签；通过个性化内容和活动重新激活未成交客户。"
      -   **成果指标:**
          -   **指标名称:** "线索转化率", **对比/增减类型:** "大幅提高"

      -   **案例场景/客户描述:** "某国际鞋服品牌"
      -   **实施策略/功能应用:** "部署私域导购Agent，整合时尚趋势和人体科学知识，通过智能询问匹配尺码和款式。"
      -   **成果指标:**
          -   **指标名称:** "退货率", **数值:** 60, **单位:** "%", **对比/增减类型:** "降低"

      -   **案例场景/客户描述:** "某食品企业"
      -   **实施策略/功能应用:** "部署内容获客AI Agent，实现热点秒级响应、多模态内容生成和效果实时调优。"
      -   **成果指标:**
          -   **指标名称:** "内容产能", **数值:** 10, **单位:** "倍", **对比/增减类型:** "提升", **时间周期:** "近"
          -   **指标名称:** "热点内容上线速度", **数值:** 2, **单位:** "小时", **对比/增减类型:** "从48小时缩短至"
          -   **指标名称:** "播放量", **数值:** 40, **单位:** "%", **对比/增减类型:** "高于", **对比基准:** "行业均值"

      -   **案例场景/客户描述:** "某时尚男装品牌"
      -   **实施策略/功能应用:** "部署会员运营AI Agent，实现动态画像生成和基于“SEVA模型”的剧本化触达。"
      -   **成果指标:**
          -   **指标名称:** "会员画像完整度", **数值:** 90, **单位:** "%以上", **对比/增减类型:** "从62%提升至"
          -   **指标名称:** "会员复购率", **数值:** 58, **单位:** "%", **对比/增减类型:** "提升至"

      -   **案例场景/客户描述:** "某运动品牌"
      -   **实施策略/功能应用:** "部署智能导购Agent，通过“体型算法+时尚知识库”进行三维数据决策，精准推荐尺码。"
      -   **成果指标:**
          -   **指标名称:** "尺码推荐不准导致的投诉量", **数值:** 60, **单位:** "%", **对比/增减类型:** "下降"
          -   **指标名称:** "导购转化率", **数值:** 42, **单位:** "%", **对比/增减类型:** "提升"

      -   **案例场景/客户描述:** "某家居品牌"
      -   **实施策略/功能应用:** "部署销售陪练Agent，通过数据化追踪生成“能力雷达图”，进行针对性补训。"
      -   **成果指标:**
          -   **指标名称:** "团队人均成单量", **数值:** 2.3, **单位:** "倍", **对比/增减类型:** "提升"

      -   **案例场景/客户描述:** "某车企"
      -   **实施策略/功能应用:** "应用销售陪练Agent的剧本生成引擎，覆盖128个销售场景。"
      -   **成果指标:**
          -   **指标名称:** "新人培训周期", **数值:** 21, **单位:** "天", **对比/增减类型:** "缩短至"

      -   **案例场景/客户描述:** "某金融机构（银行）"
      -   **实施策略/功能应用:** "上线金融行业解决方案，针对代发企业客户进行分层营销。"
      -   **成果指标:**
          -   **指标名称:** "代发客户资金留存率", **数值:** 38, **单位:** "%", **对比/增减类型:** "提升", **时间周期:** "产品上线2个月"
          -   **指标名称:** "AUM", **数值:** 21, **单位:** "%", **对比/增减类型:** "平均提升", **时间周期:** "产品上线2个月"
          -   **指标名称:** "沉睡客户激活", **数值:** 13000, **单位:** "户", **对比/增减类型:** "超过", **时间周期:** "产品上线2个月"
      -   **客户证言/评价 (ClientTestimonial):**
          -   "'和Marketingforce的合作，为正官庄的品牌注入新的活力，打造创新型电商，精准定位会员需求，帮我们在中国市场建立起更好的口碑。'——正官庄"
          -   "'Marketingforce在管理销售业务方面具有强大优势，与Marketingforce合作越久，越能感受到他们的技术服务对于企业增长的帮助。'——奇瑞新能源"
          -   "'集团旗下的品牌业务线很多，Marketingforce帮我们整合全渠道的数据资源，统一管理分散的渠道，实现会员价值的全面提升。'——皇氏乳业"
          -   "'Marketingforce提供的数字化产品服务，比如CDP、SCRM，帮我们从客户数据资产中挖掘出更多增长机会。'——恒源祥"
          -   "'Marketingforce给银行业的营销带来了新的可能，使我们能在更丰富的场景中高效提升业绩。'——民生银行"

  ## 6. 市场声誉与联系方式 (Company.ReputationAndContact)

  -   **推荐指数/口碑评分 (RecommendationScore):**
      -   **来源/描述:** "中国最大的营销及销售SaaS公司 (来源：弗若斯特沙利文)"
      -   **来源/描述:** "连续7年蝉联AI SaaS影响力企业第一名 (中国科学院《互联网周刊》)"
      -   **来源/描述:** "入选《2025年全球企业级AI Agent优秀厂商图谱》 (第一新声智库)"
  -   **联系方式 (ContactInfo):**
      -   **电话:** "400-10-71360"
      -   **官网:** "https://www.marketingforce.com/"
      -   **邮箱:** "IR@Marketingforce.com"
      -   **微信公众号:** "迈富时公众号", "珍岛T云服务平台", "迈富时AI研究院"
      -   **咨询入口描述:** "1v1专家咨询", "在线预约咨询"`

export const companyStr = `实体：公司 (Company)
	1. 公司基础信息 (Company.BasicInfo)


公司名称 (Name): 珍岛信息技术（上海）股份有限公司
公司简称 (ShortName): Marketingforce, 迈富时, 珍岛集团
成立时间 (FoundingTime): "2009年"
总部所在地 (Headquarters): "上海市静安区江场路1401弄上海市大数据产业基地"

	2. 公司级核心价值与背景 (Company.OverallValue)


公司级行业痛点描述 (CompanyPainPoints):
"获客成本居高难下"
"客户信息资产管理困难"
"数据孤岛，数据价值无法挖掘"
"私域资产增值困难"
"营销效果难以量化与追踪"
"企业数字化转型路径模糊"
"缺乏持续增长的核心驱动力"
"服务过程难掌控，用户体验不统一"
"客户流失率高"
公司级战略定位/方法论 (CompanyStrategy):
"全球领先的AI SaaS智能营销云平台"
"聚焦数字化与智能化，提供有竞争力的产品与服务，持续为客户创造价值"
"打造 IaaS/PaaS/SaaS三层服务架构，为企业提供灵活、经济的软件服务及个性化拓展"
"以“企业数字化、智能化增长”为核心，提供高价值解决方案"
"AI Agent赋能千行百业"
"从流量池到心智池的跃迁"
所获荣誉与认证 (AwardsAndCertifications):
"中国最大的营销及销售SaaS公司 (来源：弗若斯特沙利文)"
"国家科学技术进步二等奖 (国务院颁发)"
"上海市科学技术奖一等奖"
"连续7年蝉联AI SaaS影响力企业第一名"
"国家中小企业公共服务示范平台"
"中国互联网百强企业"
"国家高新技术企业"
"示范院士专家工作站"
"上海软件和信息技术服务业百强"
"2020上海软件核心竞争力企业（创新型）"
"《2025年全球企业级AI Agent优秀厂商图谱》入选"
"年度人工智能引领奖 (STIF第五届国际科创节)"
"科技企业ESG先锋奖 (STIF第五届国际科创节)"
"腾讯智慧零售“千域计划”三项大奖"
"2024业务中台企业TOP2 (中国社科院信息化研究中心联合《互联网周刊》)"
"累计申请软件著作和专利750余项"
融资情况 (Funding):
轮次: 上市
股票代码: "02556.HK"
团队背景 (TeamBackground):
团队规模: "团队规模4000+", "千人规模研发团队"
核心成员履历:
"赵旭隆，Marketingforce迈富时创始人&董事长"
"Gary Zhao (赵国帅)，集团执行董事、联席董事长及全球执行总裁，前HPE战略总顾问、OpenText生态联盟执行主席"
"付尧，集团副总裁，拥有近20年跨行业数智化服务与团队管理经验，曾服务于IBM、Toshiba等"
"顶尖技术团队，90%以上为硕士和博士，毕业于国内外顶级院校"
团队专长: "大数据、人工智能技术、云计算在数字营销及企业数字化转型领域的创新与整合"
公司市场数据/规模 (CompanyMarketData):
指标名称: "服务客户数量", 数值: 200000, 单位: "家", 时间点/周期: "累计"
指标名称: "覆盖分支机构", 数值: 20, 单位: "余家", 对比基准: "全球"
指标名称: "获客投入", 数值: 58, 单位: "%", 对比/增减类型: "下降"
指标名称: "成交时间", 数值: 35, 单位: "%", 对比/增减类型: "加快"
指标名称: "客单价", 数值: 46, 单位: "%", 对比/增减类型: "整体提升"
指标名称: "客户满意度", 数值: 25, 单位: "%", 对比/增减类型: "提高"

	3. 核心产品线与市场定位 (Company.ProductLines)
	核心产品线：营销云 (Marketing Cloud)


产品列表 (ProductList):
产品名称 (ProductName): T云
产品定位/口号 (ProductSlogan): "轻松获取线索，高效开展营销"
产品解决的行业痛点 (ProductSpecificPainPoints): ["网络流量获取难", "营销物料生产效率低", "多渠道管理复杂", "营销效果无法闭环分析"]
技术原理/架构 (TechnicalPrinciple): "SaaS化部署", "PaaS中台", "行业专属大模型"
核心功能模块 (FeatureModules):
功能名称: "平台智能搭建", 功能描述: "快速完成官网、小程序、电子名片、H5页面等平台的灵活配置与搭建。", 解决痛点: "建站门槛高"
功能名称: "内容智能生成", 功能描述: "内置臻文、臻图、臻视等AI工具，通过AI助力高效生产文章、图片、短视频等营销素材。", 解决痛点: "内容生产效率低", "创意枯竭"
功能名称: "内容智能分发", 功能描述: "覆盖搜索、媒体、短视频、微信四大主流生态，实现多渠道一键分发与管理。", 解决痛点: "多平台手动发布耗时费力"
功能名称: "商机洞察", 功能描述: "提供营销全链路数据捕捉分析，包括流量监测、AI测评、BI决策支持。", 解决痛点: "数据分散难以归因", "营销效果不透明"
产品技术优势/独特性 (ProductTechAdvantages): "PaaS中台支持快速增加新功能板块，抢占新渠道流量红利", "全布局埋点，沉淀海量行业数据，形成行业专属大模型"
产品名称 (ProductName): 视频魔方
产品定位/口号 (ProductSlogan): "轻松玩转企业短视频营销"
产品解决的行业痛点 (ProductSpecificPainPoints): ["账号定位困难", "内容创作乏力", "短视频流量无法破圈", "运营经验缺乏"]
核心功能模块 (FeatureModules):
功能名称: "AI脚本创作", 功能描述: "提供核心主题及对应指令，AI辅助快速生成创意短视频脚本。", 解决痛点: "内容创意不足"
功能名称: "AI脚本仿写", 功能描述: "输入热门脚本内容，一键仿写，分分钟生成相似热门同款短视频脚本。", 解决痛点: "内容创作效率低"
功能名称: "视频拓词", 功能描述: "根据短视频标签规则智能生成热门话题、关键词，发布时智能添加，提升视频权重和播放量。", 解决痛点: "流量无法破圈"
功能名称: "多平台矩阵分发", 功能描述: "一站式管理多渠道视频账号数据，打造视频流量池。", 解决痛点: "多账号操作繁琐"
功能名称: "同城拓客", 功能描述: "AI智能生成宣传视频获客二维码，适合餐饮、健身、教育等本地生活行业进行二次营销裂变。", 解决痛点: "获客成本高"
产品名称 (ProductName): 自媒体矩阵
产品定位/口号 (ProductSlogan): "从自媒体内容创作到线索转化的一站式赋能"
产品解决的行业痛点 (ProductSpecificPainPoints): ["多平台账号管理繁琐", "内容创作效率低", "内容合规风险", "运营效果难以追踪"]
核心功能模块 (FeatureModules):
功能名称: "多账号统一管理", 功能描述: "多平台、多账号同时管理，保障品牌一致性。", 平台支持: ["百家号", "头条号", "知乎", "微信公众号", "新浪微博", "企鹅号", "搜狐号", "大鱼号", "惠头条", "快传号"]
功能名称: "内容智能生成", 功能描述: "多标题、摘要、标签智能生成，辅助提升搜索排序，获得更多推荐曝光。", 解决痛点: "内容创作乏力"
功能名称: "智能风险预警", 功能描述: "智能检测内容中是否含有涉政、暴恐、色情、广告等信息，规避风险。", 解决痛点: "平台风控压力大"
功能名称: "多平台一键分发", 功能描述: "多体裁一键同步分发至10+主流自媒体平台，减少繁琐重复操作。", 解决痛点: "手动发布耗时费力"
功能名称: "运营数据可视化", 功能描述: "打通自媒体内容全链路流转数据，商机线索、私信留言直观展示，让内容营销效果可视化。", 解决痛点: "数据分散难以归因"
产品名称 (ProductName): 宝盟
产品定位/口号 (ProductSlogan): "您身边的AI推广智投管家"
产品解决的行业痛点 (ProductSpecificPainPoints): ["缺乏互联网营销经验", "缺少专业型人才", "推广预算成本有限", "缺乏品牌营销意识"]
核心功能模块 (FeatureModules):
功能名称: "智能定投", 功能描述: "无需备案，在高权重B2B站点进行智能定投发布。", 解决痛点: "传统SEO效果衰减"
功能名称: "AI智能操作", 功能描述: "平台战略合作，商机智能分发，无需人工操作，智能拓词、智能商情分发、智能定时发布。", 解决痛点: "人工操作效率低下"
功能名称: "智能刷新", 功能描述: "检测发布信息页面可访问状态，智能推荐商机更新，多渠道吸引流量。", 解决痛点: "排名不稳定"
产品技术优势/独特性 (ProductTechAdvantages): "聚拢了中文B2B平台80%的商业流量，每月3000多万的IP", "多家战略联盟覆盖80%的B2B流量"
产品名称 (ProductName): T云海外版
产品定位/口号 (ProductSlogan): "让海外营销变简单！"
产品解决的行业痛点 (ProductSpecificPainPoints): ["打开海外市场难", "缺乏海外客户线索", "营销活动建立复杂", "企业数据资产无法沉淀"]
核心功能模块 (FeatureModules):
功能名称: "平台智能搭建", 功能描述: "提供智能化的独立站搭建平台，无需专业技术知识，快速灵活搭建个性化平台。", 解决痛点: "技术门槛高"
功能名称: "海外企业数据库", 功能描述: "提供海外企业信息和联系方式的数据库，帮助用户快速找到目标市场的潜在客户。", 解决痛点: "获客渠道单一"
功能名称: "自动化营销流程", 功能描述: "通过大数据和AI技术，自动执行销售动作，包括线索获取、跟进、推送信息等，实现24小时不间断的销售活动。", 解决痛点: "人工操作效率低下"
功能名称: "多方式触达转化", 功能描述: "通过邮件、Whatsapp、社交媒体等渠道与潜在客户建立联系，进行个性化沟通和推广。", 平台支持: [、"Whatsapp", "社交媒体"]
产品名称 (ProductName): GMA增长营销自动化平台
产品定位/口号 (ProductSlogan): "让企业拥有持续增长核心驱动力"
产品解决的行业痛点 (ProductSpecificPainPoints): ["运营活动策略制定难", "用户筛选不精准", "用户触达手段单一", "活动效果分析不实时"]
核心功能模块 (FeatureModules):
功能名称: "流程画布", 功能描述: "可视化搭建自动营销流程，构建个性化的用户旅程，在不同触点自动化地传递信息，引导用户转化。", 解决痛点: "营销流程复杂", "客户流失严重"
功能名称: "用户精准筛选", 功能描述: "通过用户属性和行为数据洞察，丰富的分群和标签随需随取，快速筛选精准人群。", 解决痛点: "缺乏360°客户视图"
功能名称: "多渠道精细化触达", 功能描述: "打通短信、微信、弹框、APP推送等多种用户触达通道。", 解决痛点: "触达方式单一"
功能名称: "实时效果分析", 功能描述: "提供实时的活动看板，让运营效果一览无遗，数据驱动方案迭代。", 解决痛点: "营销效果不透明"
产品名称 (ProductName): 社媒VOC（客户之声）
产品定位/口号 (ProductSlogan): "全面倾听客户的反馈和需求"
产品解决的行业痛点 (ProductSpecificPainPoints): ["无法高效全面监测社媒口碑", "负面舆情响应滞后", "营销活动效果评估难", "竞品分析效率低"]
技术原理/架构 (TechnicalPrinciple): "NLP语义分析", "传播影响力模型", "发酵模型", "异常账号识别模型"
核心功能模块 (FeatureModules):
功能名称: "一站式社媒监测", 功能描述: "监测范围覆盖国内外主流社媒、传统网媒、搜索引擎；80%帖子发布1小时内能够监测到。", 解决痛点: "信息获取不及时"
功能名称: "负面舆情识别与预警", 功能描述: "通过NLP语义分析识别负面声音，并按照发帖人粉丝数、互动数等进行分级、分角色预警。", 平台支持: ["飞书", "钉钉", "企业微信"]
功能名称: "营销活动效果分析", 功能描述: "AI筛选活动发帖，通过活动声量趋势、情感度趋势、词云等评估活动效果并及时调整策略。", 解决痛点: "营销效果不透明"
功能名称: "社媒获客与线索挖掘", 功能描述: "通过算法挖掘筛选评论、私信及弹幕中高意向客户，形成社媒线索池。", 解决痛点: "获客渠道单一"

	核心产品线：销售云 (Sales Cloud)


产品列表 (ProductList):
产品名称 (ProductName): 珍客SCRM (SCRM私域客户资产运营)
产品定位/口号 (ProductSlogan): "构建全链路私域运营，打造数字化客户资产管理平台"
产品解决的行业痛点 (ProductSpecificPainPoints): ["公域流量贵，获客成本高", "触达方式单一，用户易流失", "销售服务水平不一", "用户复购率低"]
核心功能模块 (FeatureModules):
功能名称: "全渠道获客", 功能描述: "连接智能广告平台，打通公域到私域，基于大数据分析投放效果，反哺获客渠道(look-alike)，提高投放ROI。", 解决痛点: "获客成本高"
功能名称: "自动化精准触达", 功能描述: "接入营销自动化MA，基于客户全生命周期管理，触发自动化营销内容，实现千人千面营销。", 解决痛点: "用户流失严重"
功能名称: "标准化展业", 功能描述: "提供“话术库+素材库+客户SOP”的黄金展业组合，为销售人员赋能，快速提升服务水平。", 解决痛点: "销售能力参差不齐"
功能名称: "会话风控质检", 功能描述: "支持会话存档和敏感词提醒，规范销售管理过程，保障企业客户资产。", 解决痛点: "客户资产流失"
产品名称 (ProductName): 客户数据平台CDP
产品定位/口号 (ProductSlogan): "打通全域数据构建360°企业用户画像"
产品解决的行业痛点 (ProductSpecificPainPoints): ["数据孤岛", "用户画像不清晰", "无法进行精细化运营", "线索转化率低"]
核心功能模块 (FeatureModules):
功能名称: "多源数据接入与治理", 功能描述: "支持mysql、hive等多种数据库、excel/csv文件及API接口对接，提供可视化建模进行数据清洗。", 解决痛点: "数据孤岛"
功能名称: "One-ID体系", 功能描述: "整合客户数据，打通各渠道的用户ID，识别并合并多用户关系，形成统一用户视图。", 解决痛点: "客户信息分散"
功能名称: "360°用户洞察", 功能描述: "通过对客户360°画像及分群透视分析，帮助进行精细化运营、个性化触达、精准投放。", 解决痛点: "缺乏360°客户视图"
功能名称: "标签与分群能力", 功能描述: "支持规则创建、导入创建、lookalike等11种模式创建标签和分群，高效完成用户标签体系。", 解决痛点: "用户分层管理难"
产品名称 (ProductName): 珍客CRM (CRM客户关系管理)
产品定位/口号 (ProductSlogan): "提供企业销售数字化转型的综合解决方案"
产品解决的行业痛点 (ProductSpecificPainPoints): ["客户信息管理混乱", "销售流程不规范", "商机转化率低", "缺乏数据分析辅助决策"]
核心功能模块 (FeatureModules):
功能名称: "360度客户洞察", 功能描述: "展示客户全生命周期的活动，从线索到成交，让销售清晰掌握客户的每一个活动。", 解决痛点: "客户信息分散"
功能名称: "商机管理", 功能描述: "精细化管理每个商机，通过制定每个阶段的任务和动作，指导销售更高效的转化商机。", 解决痛点: "销售流程混乱"
功能名称: "移动办公", 功能描述: "支持通过浏览器或移动应用，让销售随时随地查阅和更新销售进展。", 解决痛点: "销售效率低"
功能名称: "Sales Analytics", 功能描述: "基于BI能力，将报表与驾驶舱能力与CRM相结合，支持多样的报表可视化与钻取分析。", 解决痛点: "缺乏数据驱动决策"
产品名称 (ProductName): 臻推宝
产品定位/口号 (ProductSlogan): "想要销售好，就用“臻推宝”"
产品解决的行业痛点 (ProductSpecificPainPoints): ["销售线索难找", "客户信任难建立", "营销物料制作耗时", "客户资产无法沉淀"]
核心功能模块 (FeatureModules):
功能名称: "智能商务名片", 功能描述: "每个员工专属的微信小程序名片，360°全景展示个人、公司、产品信息，链接12亿微信用户生态圈。", 解决痛点: "品牌曝光不足"
功能名称: "全员智能推广系统", 功能描述: "提供品牌海报、热点文库、宣传册等系统，支持一键生成和分享，实现社群裂变。", 解决痛点: "内容创作效率低"
功能名称: "有效获客转化系统", 功能描述: "实时掌握访客行为轨迹，智能分析客户意向，并通过在线客服系统快速沟通，不加微信好友也能沟通。", 解决痛点: "客户意向不明确"
功能名称: "销售分析管理系统", 功能描述: "提供推广数据看板，实现订单数据可视化，将访客信息沉淀为企业客户资产池。", 解决痛点: "客户资产流失"
产品名称 (ProductName): AI-Sales 海外销售专家 (Eva, Nora, Max)
产品定位/口号 (ProductSlogan): "AI驱动的海外销售专家"
产品解决的行业痛点 (ProductSpecificPainPoints): ["传统海外开发效率低", "目标客户不精准", "决策人难找", "营销内容缺乏个性化", "人力成本高"]
技术原理/架构 (TechnicalPrinciple): "千亿级海外数据智库", "AI Agent"
核心功能模块 (FeatureModules):
功能名称: "Eva - 海外开发专家", 功能描述: "基于千亿级海外数据智库，智能搜索并开发潜在客户，智能发送个性化营销邮件。", 解决痛点: "获客渠道单一"
功能名称: "Nora - 社媒营销顾问", 功能描述: "智能生成社媒内容计划，自动排期发布，精准互动，打造品牌影响力。", 解决痛点: "内容生产效率低"
功能名称: "Max - 客户销售管家", 功能描述: "自动跟进客户动态，更新客户画像，提升复购率和客户忠诚度。", 解决痛点: "客户跟进不及时"
产品技术优势/独特性 (ProductTechAdvantages): "覆盖200+国家市场，自动适配时区与语言", "每日分析百万次交互数据，动态优化营销策略"

	核心产品线：商业云 (Business Cloud)


产品列表 (ProductList):
产品名称 (ProductName): 智能体商城 (T-SHOP 智慧商城)
产品定位/口号 (ProductSlogan): "打通企业线上线下商业能力"
产品解决的行业痛点 (ProductSpecificPainPoints): ["多渠道店铺管理难", "缺乏新零售场景支持", "营销活动单一", "运营人效低"]
核心功能模块 (FeatureModules):
功能名称: "全渠道整合", 功能描述: "一站式管理微信小店、抖音、天猫、京东等多渠道的商品、订单、营销、物流、售后。", 平台支持: ["视频号", "天猫", "京东", "快手", "抖音", "小红书"]
功能名称: "多场景适配", 功能描述: "高度灵活定义，可快速搭建社交电商、内容电商、分销商城、会员商城等新零售场景。", 解决痛点: "业务场景支持不足"
功能名称: "大数据智能", 功能描述: "运用大数据、人工智能技术，通过对消费者行为和偏好的分析，提供个性化的推荐和定制化的服务。", 解决痛点: "缺乏个性化推荐"
功能名称: "丰富的营销活动", 功能描述: "支持优惠券、打折、促销、秒杀、满减等丰富营销模式，实现快速引流转化。", 解决痛点: "营销玩法单一"
产品名称 (ProductName): 智慧门店 (T-Shop 智慧门店)
产品定位/口号 (ProductSlogan): "有效整合线上与线下门店的资源、打破传统门店的边界"
产品解决的行业痛点 (ProductSpecificPainPoints): ["线上线下业务脱节", "客户忠诚度低、复购率低", "门店管理效率低", "缺乏数据驱动决策"]
核心功能模块 (FeatureModules):
功能名称: "营销赋能", 功能描述: "通过全链路激活促销、建立完善的会员体系等方式，高效提高客户的忠诚度和复购率。", 解决痛点: "客户留存率低"
功能名称: "管理赋能", 功能描述: "提供有效的商品库存管理系统、订单分佣机制和数字化的决策支持。", 解决痛点: "管理流程复杂"
功能名称: "多渠道快速引流", 功能描述: "构建会员体系和数字化营销工具，高效地将流量引导至线上及线下门店。", 解决痛点: "获客渠道单一"
产品名称 (ProductName): 会员中心 (T-Shop 会员中心)
产品定位/口号 (ProductSlogan): "全渠道线上线下会员管理平台"
产品解决的行业痛点 (ProductSpecificPainPoints): ["多渠道会员数据不通", "会员体系单一", "用户活跃度和复购率低"]
核心功能模块 (FeatureModules):
功能名称: "全渠道对接", 功能描述: "对接京东、淘宝、拼多多、小红书、抖店、快手等平台整合全渠道会员数据，一站式查看管理。", 平台支持: ["京东", "淘宝", "小红书", "拼多多", "有赞", "微盟", "美团", "抖店"]
功能名称: "多会员体系", 功能描述: "支持商户同时配置多套会员模板，适配大型企业一品牌一会员体系的运营场景。", 解决痛点: "集团多品牌管理难"
功能名称: "会员激励体系", 功能描述: "支持会员分销、会员勋章、积分商城等玩法，促进用户活跃与复购。", 解决痛点: "用户互动低迷"

	核心产品线：分析云 (Analysis Cloud)


产品列表 (ProductList):
产品名称 (ProductName): 智能可视化BI
产品定位/口号 (ProductSlogan): "支持千亿级数据、亚秒级查询，让客户轻松的洞察数据价值"
产品解决的行业痛点 (ProductSpecificPainPoints): ["数据分散在多系统", "IT知识门槛高", "数据分析维度单一", "缺乏预测性洞察"]
核心功能模块 (FeatureModules):
功能名称: "轻松整合数据", 功能描述: "具有强大的数据集成能力，能够从ERP、CRM、财务系统等多个源头抽取数据，打破数据孤岛。", 解决痛点: "数据孤岛"
功能名称: "零门槛数据探索", 功能描述: "提供直观易用的界面和拖拽式报告生成工具，支持自动生成图表、自然语言交互。", 解决痛点: "IT运维依赖专职人员"
功能名称: "AI智能应用模型", 功能描述: "连接采购、库存、物流等环节，提供实时关键指标，辅助企业做出最佳采购决策；整合员工信息、绩效数据等，发现人才流失原因。", 解决痛点: "缺乏数据驱动决策"
功能名称: "自定义指标预测", 功能描述: "利用预测分析能力，企业可提前预警潜在的财务风险，并依据历史和趋势数据调整财务策略。", 解决痛点: "缺乏风险预警"

	核心产品线：智能云 (Smart Cloud)


产品列表 (ProductList):
产品名称 (ProductName): AI-Agentforce智能体中台
产品定位/口号 (ProductSlogan): "打造企业级、生产级的智能体（Agent）一站式开发与运营平台"
产品解决的行业痛点 (ProductSpecificPainPoints): ["自研智能体开发周期长、技术风险高、运维成本大", "AI试水难以走向AI工业化", "技术门槛高", "缺乏可复用的AI能力"]
技术原理/架构 (TechnicalPrinciple): "Agentic工作流编排", "RAG知识引擎", "智能体DevOps全生命周期管理", "多模态AI Agent引擎"
核心功能模块 (FeatureModules):
功能名称: "一体化开发", 功能描述: "一个平台集成框架设计、知识库管理、API连接、工作流编排、模型调度，降低开发门槛。", 解决痛点: "AI营销落地技术门槛高"
功能名称: "分钟级构建", 功能描述: "提供上百个行业场景智能体模板，业务人员像组装乐高一样搭建流程。修改知识库或流程逻辑秒级生效。", 解决痛点: "需求响应滞后"
功能名称: "统一运维", 功能描述: "实时监控Agent运行状态、自动告警异常、分析性能瓶颈，实现全程可视化管理。", 解决痛点: "系统运维复杂"
功能名称: "多租户私有化部署", 功能描述: "支持集团内部多子公司、部门共享系统资源，同时拥有逻辑隔离的专属开发空间，实现企业级安全管控。", 解决痛点: "数据安全与合规压力"
产品技术优势/独特性 (ProductTechAdvantages): "将企业AI生产力重构为“可复用的能力层”", "“自然语言驱动+可视化编排”的双模交互", "支持“智能体市场”共享模板与最佳实践"
产品名称 (ProductName): T-Talk智能客服
产品定位/口号 (ProductSlogan): "提人效，促成单，访客接待一体化"
产品解决的行业痛点 (ProductSpecificPainPoints): ["客户来源渠道分散，接待耗时", "大量重复问题导致客服人效低", "非工作时间无人接待", "无法提前预判客户意图"]
核心功能模块 (FeatureModules):
功能名称: "全渠道接入, 7*24 全天候接待", 功能描述: "支持接入官网、APP、商铺等站点，机器人客服随时响应，无缝衔接人工。", 解决痛点: "响应滞后"
功能名称: "内置行业语料", 功能描述: "行业语料库轻松导入，机器人懂行会接话，提供侧边栏快捷回复，支持人机协作提效。", 解决痛点: "客服专业能力不足"
功能名称: "营销小组件", 功能描述: "提供6种入口样式，9种邀请弹窗，互动吸睛引导会话，超时未接待时主动引导留资。", 解决痛点: "线索转化率低"
功能名称: "精准记录访客轨迹", 功能描述: "访客看板记录访客来源、访问轨迹，了解访客兴趣点，精准洞察用户需求。", 解决痛点: "缺乏客户洞察"
产品名称 (ProductName): 臻文
产品定位/口号 (ProductSlogan): "为用户提供更新快、覆盖全、质量高的原创文章内容和辅助创作平台"
技术原理/架构 (TechnicalPrinciple): "自然语言处理", "知识图谱", "深度学习", "语义分析"
核心功能模块 (FeatureModules):
功能名称: "智能辅助创作", 功能描述: "海量专业素材智能推荐，主题写作一键生成标题、摘要等。", 解决痛点: "创意枯竭"
功能名称: "文章生成", 功能描述: "设定创作主题、行业，即可批量生成原创文章。", 解决痛点: "内容生产效率低"
功能名称: "原创改写", 功能描述: "对已有文章进行在线快速改写，支持批量原创、锁词、替换词等操作。", 解决痛点: "内容同质化"
产品名称 (ProductName): 臻图
产品定位/口号 (ProductSlogan): "智能营销设计云平台"
核心功能模块 (FeatureModules):
功能名称: "AI绘图", 功能描述: "支持文生图、图生图，6秒生成，8000+词汇组合助力艺术创作。", 解决痛点: "缺乏高质量图片素材"
功能名称: "智能生成", 功能描述: "根据固定主图智能生成多张场景图片，快速赋能营销。", 解决痛点: "设计效率低"
功能名称: "自动抠图", 功能描述: "一键智能抠图，自动识别主体并剔除背景，发丝清晰可见。", 解决痛点: "图片处理复杂"
产品名称 (ProductName): 臻视
产品定位/口号 (ProductSlogan): "全能易用的短视频创作推广工具"
核心功能模块 (FeatureModules):
功能名称: "模板广场", 功能描述: "提供海量视频模板，匹配企业全场景业务需求，一键套用，极速生成。", 解决痛点: "缺乏专业视频制作能力"
功能名称: "图文快闪", 功能描述: "无需基础，替换图文，1秒即可生成爆款快闪卡点视频。", 解决痛点: "传统视频制作周期长"
功能名称: "AI智能配音与字幕", 功能描述: "旁白声音自由选择，语速快慢任意切换；机器自动识别语音，一键完成字幕添加。", 解决痛点: "视频后期制作复杂"
产品名称 (ProductName): 智能体一体机
产品定位/口号 (ProductSlogan): "智慧、安全、高效的最新一代解决方案"
产品解决的行业痛点 (ProductSpecificPainPoints): ["数据安全约束，必须私有化部署", "公文/报告等需求响应低效", "大模型落地技术适配门槛高"]
部署方式 (DeploymentMethod): "私有化部署"
核心功能模块 (FeatureModules):
功能名称: "20+政务智能体", 功能描述: "提供法律法规问询、纪检信访回复、招商辅助、公文拟制、政策文件解析等超过20种开箱即用的政务智能体。", 解决痛点: "政务办公效率低"
功能名称: "数据安全保障", 功能描述: "能够根据政府的组织架构、管理规范进行租户隔离,支持安全管理机制。", 解决痛点: "数据安全与合规压力"
功能名称: "多模型协作架构", 功能描述: "支持多模型调度及管理,支持租户级隔离机制。", 解决痛点: "技术适配门槛高"
产品技术优势/独特性 (ProductTechAdvantages): "AI国产化+自主可控，构建政企数智新生态", "软硬件一体化交付"

	核心产品线：组织云 DHR (DHR Cloud)


产品列表 (ProductList):
产品名称 (ProductName): DHRforce (德招聘, 德人才, 德学堂)
产品定位/口号 (ProductSlogan): "基于Tforce大模型的人才甄选、人岗匹配与人才发展一体化智能管理平台"
产品解决的行业痛点 (ProductSpecificPainPoints): ["人才获取渠道单一", "人才识别不准", "人事管理效率低", "人才培养体系不健全"]
技术原理/架构 (TechnicalPrinciple): "Tforce大模型AIGC与智能体中台"
核心功能模块 (FeatureModules):
功能名称: "德招聘-智能招聘", 功能描述: "全流程自动化，对接10+外部招聘渠道，提供智能简历解析和筛查，实现AI人岗匹配。", 解决痛点: "招聘效率低", "人才识别失误率高"
功能名称: "德人才-人才测评", 功能描述: "全面覆盖人才评估冰山模型，提供心理风险评估、认知能力测评、关键岗位潜质测评等。", 解决痛点: "人才评估不科学"
功能名称: "德学堂-在线培训", 功能描述: "提供AI陪练助手模拟真实业务场景，AI出题出卷与智能批阅，新员工入职自动推送学习计划。", 解决痛点: "培训效果难以量化"
产品技术优势/独特性 (ProductTechAdvantages): "AI+招测学考一体化流程，从精准识人到精准用人", "深入招、测、学全场景的一体化HR SaaS方案"

	4. 产品级行业适配与价值主张 (Company.Product.IndustryFit)


目标行业 (TargetIndustries): ["零售消费", "汽车", "金融保险", "B2B制造业", "教育", "医疗大健康", "政务", "家居电工", "跨境电商", "家装", "餐饮"]
客户群体特征 (ClientCharacteristics): ["中大型企业", "集团企业", "中小微企业", "出海企业", "院校", "政府机构"]

	5. 产品级典型应用案例与量化成果 (Company.Product.CaseStudies)


案例列表 (CaseList):
案例场景/客户描述: "公牛集团（家居电工与照明）"
实施策略/功能应用: "以“全域场景触达 + 客资精细运营 + 组织能力培育”的数智策略，部署微信小程序商城、SCRM系统、自媒体矩阵运营体系和“德学堂”员工培训平台。"
关联价值: "让线下门店从交易场景升级为全域运营的枢纽，让导购的服务经验转化为标准化的组织能力，让品牌与用户的每一次互动都成为可沉淀的运营资产。"
案例场景/客户描述: "某医药大健康品牌"
实施策略/功能应用: "部署AI-Agentforce企业级智能体中台，通过“AI+CDP”打通全渠道数据，构建360度客户档案；AI Agent进行分层式用户管理并自动识别复购黄金期，精准推送会员活动。"
成果指标:
指标名称: "新会员转化率", 对比/增减类型: "大幅提升"
指标名称: "全域会员GMV", 对比/增减类型: "突破历史新高"
案例场景/客户描述: "某头部新能源车企"
实施策略/功能应用: "部署AI数字员工，作为24小时在线咨询顾问，精准捕捉用户需求并记录标签；通过个性化内容和活动重新激活未成交客户。"
成果指标:
指标名称: "线索转化率", 对比/增减类型: "大幅提高"
案例场景/客户描述: "某国际鞋服品牌"
实施策略/功能应用: "部署私域导购Agent，整合时尚趋势和人体科学知识，通过智能询问匹配尺码和款式。"
成果指标:
指标名称: "退货率", 数值: 60, 单位: "%", 对比/增减类型: "降低"
案例场景/客户描述: "某食品企业"
实施策略/功能应用: "部署内容获客AI Agent，实现热点秒级响应、多模态内容生成和效果实时调优。"
成果指标:
指标名称: "内容产能", 数值: 10, 单位: "倍", 对比/增减类型: "提升", 时间周期: "近"
指标名称: "热点内容上线速度", 数值: 2, 单位: "小时", 对比/增减类型: "从48小时缩短至"
指标名称: "播放量", 数值: 40, 单位: "%", 对比/增减类型: "高于", 对比基准: "行业均值"
案例场景/客户描述: "某时尚男装品牌"
实施策略/功能应用: "部署会员运营AI Agent，实现动态画像生成和基于“SEVA模型”的剧本化触达。"
成果指标:
指标名称: "会员画像完整度", 数值: 90, 单位: "%以上", 对比/增减类型: "从62%提升至"
指标名称: "会员复购率", 数值: 58, 单位: "%", 对比/增减类型: "提升至"
案例场景/客户描述: "某运动品牌"
实施策略/功能应用: "部署智能导购Agent，通过“体型算法+时尚知识库”进行三维数据决策，精准推荐尺码。"
成果指标:
指标名称: "尺码推荐不准导致的投诉量", 数值: 60, 单位: "%", 对比/增减类型: "下降"
指标名称: "导购转化率", 数值: 42, 单位: "%", 对比/增减类型: "提升"
案例场景/客户描述: "某家居品牌"
实施策略/功能应用: "部署销售陪练Agent，通过数据化追踪生成“能力雷达图”，进行针对性补训。"
成果指标:
指标名称: "团队人均成单量", 数值: 2.3, 单位: "倍", 对比/增减类型: "提升"
案例场景/客户描述: "某车企"
实施策略/功能应用: "应用销售陪练Agent的剧本生成引擎，覆盖128个销售场景。"
成果指标:
指标名称: "新人培训周期", 数值: 21, 单位: "天", 对比/增减类型: "缩短至"
案例场景/客户描述: "某金融机构（银行）"
实施策略/功能应用: "上线金融行业解决方案，针对代发企业客户进行分层营销。"
成果指标:
指标名称: "代发客户资金留存率", 数值: 38, 单位: "%", 对比/增减类型: "提升", 时间周期: "产品上线2个月"
指标名称: "AUM", 数值: 21, 单位: "%", 对比/增减类型: "平均提升", 时间周期: "产品上线2个月"
指标名称: "沉睡客户激活", 数值: 13000, 单位: "户", 对比/增减类型: "超过", 时间周期: "产品上线2个月"
客户证言/评价 (ClientTestimonial):
"'和Marketingforce的合作，为正官庄的品牌注入新的活力，打造创新型电商，精准定位会员需求，帮我们在中国市场建立起更好的口碑。'——正官庄"
"'Marketingforce在管理销售业务方面具有强大优势，与Marketingforce合作越久，越能感受到他们的技术服务对于企业增长的帮助。'——奇瑞新能源"
"'集团旗下的品牌业务线很多，Marketingforce帮我们整合全渠道的数据资源，统一管理分散的渠道，实现会员价值的全面提升。'——皇氏乳业"
"'Marketingforce提供的数字化产品服务，比如CDP、SCRM，帮我们从客户数据资产中挖掘出更多增长机会。'——恒源祥"
"'Marketingforce给银行业的营销带来了新的可能，使我们能在更丰富的场景中高效提升业绩。'——民生银行"

	6. 市场声誉与联系方式 (Company.ReputationAndContact)


推荐指数/口碑评分 (RecommendationScore):
来源/描述: "中国最大的营销及销售SaaS公司 (来源：弗若斯特沙利文)"
来源/描述: "连续7年蝉联AI SaaS影响力企业第一名 (中国科学院《互联网周刊》)"
来源/描述: "入选《2025年全球企业级AI Agent优秀厂商图谱》 (第一新声智库)"
联系方式 (ContactInfo):
电话: "400-10-71360"
官网: "https://www.marketingforce.com/"
邮箱: "IR@Marketingforce.com"
微信公众号: "迈富时公众号", "珍岛T云服务平台", "迈富时AI研究院"
咨询入口描述: "1v1专家咨询", "在线预约咨询"
`
export const fileArr = [
  {
    id: 1,
    fileName: '文件1',
    fileSource: '文件来源1',
    fileType: '文件类型1',
    fileSize: 100,
    fileStatus: '更新状态1',
    isUpdate: '近期是否有更新1',
    knowledgeStatus: '知识状态1',
    createTime: '2021-01-01',
  },
  {
    id: 2,
    fileName: '文件2',
    fileSource: '文件来源2',
    fileType: '文件类型2',
    fileSize: 200,
    fileStatus: '更新状态2',
    isUpdate: '近期是否有更新2',
    knowledgeStatus: '知识状态2',
    createTime: '2021-01-02',
  },
  {
    id: 3,
    fileName: '文件3',
    fileSource: '文件来源3',
    fileType: '文件类型3',
    fileSize: 300,
    fileStatus: '更新状态3',
    isUpdate: '近期是否有更新3',
    knowledgeStatus: '知识状态3',
    createTime: '2021-01-03',
  },
  {
    id: 4,
    fileName: '文件4',
    fileSource: '文件来源4',
    fileType: '文件类型4',
    fileSize: 400,
    fileStatus: '更新状态4',
    isUpdate: '近期是否有更新4',
    knowledgeStatus: '知识状态4',
    createTime: '2021-01-04',
  },
  {
    id: 5,
    fileName: '文件5',
    fileSource: '文件来源5',
    fileType: '文件类型5',
    fileSize: 500,
    fileStatus: '更新状态5',
    isUpdate: '近期是否有更新5',
    knowledgeStatus: '知识状态5',
    createTime: '2021-01-05',
  },
  {
    id: 6,
    fileName: '文件6',
    fileSource: '文件来源6',
    fileType: '文件类型6',
    fileSize: 600,
    fileStatus: '更新状态6',
    isUpdate: '近期是否有更新6',
    knowledgeStatus: '知识状态6',
    createTime: '2021-01-06',
  }
]
